import { useLoaderData } from '@remix-run/react'
import { Button } from '~/components/general/Button'
import { JobTitlePageLoaderData } from '~/routes/careers.$slug.$type'

export const SalaryRange = () => {
  const { salaryData } = useLoaderData() as Pick<JobTitlePageLoaderData, 'salaryData'>
  if (!salaryData) return null

  const lowRange = salaryData.data.minimum_salary
  const highRange = salaryData.data.maximum_salary
  const average = salaryData.data.average_salary
  const averageValue = ((average - lowRange) / (highRange - lowRange)) * 100
  return (
    <div
      className="flex w-full p-6 md:p-8 flex-col items-center gap-3 rounded-2xl bg-white mt-12"
      style={{
        boxShadow:
          '0px 0px 1px 0px rgba(15, 56, 113, 0.32), 0px 1px 2px 0px rgba(15, 56, 113, 0.12), 0px 2px 4px 0px rgba(15, 56, 113, 0.08)',
      }}
    >
      <div className="flex flex-col items-start self-stretch">
        <div className="flex items-baseline gap-1 self-stretch">
          <span className="text-l text-neutral-100">${average}</span>
          <span className="text-[14px] leading-[18px] md:text-[16px] md:leading-5 text-neutral-60">
            / Year
          </span>
        </div>
        <span className="self-stretch text-[14px] leading-[18px] md:text-[16px] md:leading-5 text-neutral-60">
          Average Salary
        </span>
      </div>
      <div className="self-stretch">
        <div className="relative flex w-full h-2">
          <div className="absolute w-full h-full bg-blue-30 rounded opacity-30" />
          <div
            className="absolute h-full bg-blue-30 rounded-full"
            style={{
              width: averageValue > 100 ? '100%' : averageValue < 0 ? '0%' : `${averageValue}%`,
            }}
          />
        </div>
      </div>
      <div className="flex w-full justify-between">
        <span className="text-[14px] leading-[18px] md:text-[16px] md:leading-5 text-neutral-60">
          Low <span className="text-neutral-100">${lowRange}</span>
        </span>
        <span className="text-[14px] leading-[18px] md:text-[16px] md:leading-5 text-neutral-60">
          Average <span className="text-neutral-100">${average}</span>
        </span>
        <span className="text-[14px] leading-[18px] md:text-[16px] md:leading-5 text-neutral-60">
          High <span className="text-neutral-100">${highRange}</span>
        </span>
      </div>
      <Button
        type={'button'}
        text={'Get More Insights'}
        className={'w-full items-center justify-center'}
        size={'s'}
      />
    </div>
  )
}
